// ======================================================================
// File Name       : ContentDrillList
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { Table, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import TableHead, { setSortState } from '../../components/TableHead';
import * as Path from '../../constants/PathConstants';
import { DRILL_CLIENT_URL, RETURN_PAGE, RETURN_PAGE_END, AUTH_REDIRECT_URL } from '../../constants';
import { getItemBoxName, parseDateForDetail, setCookie } from '../../utils/index';
import { DATA_AFFIILIATION_TYPE_TEXT, DRILL_TYPE_ID, CONVERT_STATUS } from '../../constants/ContentConstant';
import { SELECT_BOX_DATA } from '../../constants/SelectBoxData';
import DrillImage from '../../images/icon/drill.png';
import store from '../../store';
import CustomLink from '../button/CustomLink';
import CustomButton from '../button/CustomButton';
import * as ICON from '../../constants/IconConstants';


const ContentDrillList = ({ drillListInfo, handleSortState, drillSearchInfo, handleMouseEnter, handleMouseLeave, hoverIndex }) => {
  const thead = [
    { title: 'ドリル識別ID', sortBy: 0},
    { title: 'ドリルタイトル', sortBy: 1 , width:'30%'},
    { title: 'ドリル種別', sortBy: 4 },
    { title: '外部', sortBy: 3, width:'5%'},
    { title: '登録日時', sortBy: 8},
    { title: '登録者', sortBy: null}, // Step 9.0.0
    { title: '変換ステータス', sortBy: 2},
    { title: '操作', sortBy: null, width:200}, // Step9.0.1
  ];
  let data = thead;
  if (drillSearchInfo) {
    const sortBy = drillSearchInfo.drillSortType;
    const sortState = drillSearchInfo.ascendingDescendingSort;
    data = setSortState(thead, sortBy, sortState);
  }
  const { authedUser } = store.getState().authed;
  const institutionId = (authedUser && authedUser.institutionId) ? authedUser.institutionId : '';
  const contentDrillList =
    drillListInfo &&
    drillListInfo.drillList &&
    drillListInfo.drillList.map((drill, index) => {
      const isShowButton = drill.drillKind != DRILL_TYPE_ID.ADAPTIVE;
      const linkDetail = `/${Path.CONTENT}/${Path.CONTENT_DRILL}/${drill.drillSecernId}`;
      // #7376 START
      const linkConfirm = `${DRILL_CLIENT_URL}/DrillTopHtml?institution_id=${institutionId}&drill_secern_id=${drill.drillSecernId}&return_page=${RETURN_PAGE}&return_page_end=${RETURN_PAGE_END}&auth_redirect_uri=${AUTH_REDIRECT_URL}&X-SSapi-version=2.0.0`;
      // #7376 END
      const isDrillConvertSuccess = drill.convertStatus === CONVERT_STATUS.CONVERSION_SUCCESS;
      return (
        <tr key={index} onMouseEnter={() => handleMouseEnter(index)} onMouseLeave={handleMouseLeave}>
          <td>
            <div > {drill.drillSecernId} </div>
          </td>
          <td>
            {drill.drillTitle}
          </td>
          <td>
            {getItemBoxName(SELECT_BOX_DATA.DRILL_KIND_LIST, drill.drillKind)}
          </td>
          <td>
            {getItemBoxName(DATA_AFFIILIATION_TYPE_TEXT, drill.dataAffiliationType)}
          </td>
          <td>
            {parseDateForDetail(drill.createdAt)}
          </td>
          {/* Step 9.0.0 START */}
          <td>
            {drill.createdUserName}
          </td>
          {/* Step 9.0.0 END */}
          <td>
            {getItemBoxName(SELECT_BOX_DATA.DRILL_STATUS, drill.convertStatus)}
          </td>
          <td className="text-center">
            <div className="inline-flex">
              {isShowButton && isDrillConvertSuccess &&
                <CustomLink
                  className="btn-edit margin-right-10"
                  onClick={() => {
                    store.dispatch(setCookie('preview_mode', 1)).then(() => {
                      window.open(linkConfirm, '_blank');
                    });
                  }}
                  text="事前確認"
                />
              }
              <CustomLink
                className="margin-right-7 link-detail-edit"
                to={linkDetail}
                text="詳細"
              />
            </div>
          </td>
        </tr>
      );
    });

  return (
    <div>
      <Table striped hover>
        <thead>
          <TableHead data={data} handleSortState={handleSortState} />
        </thead>
        <tbody>
          {contentDrillList}
        </tbody>
      </Table>
    </div>
  );
};

export default ContentDrillList;
